import { LogLevel } from "angular-auth-oidc-client";

const origin = typeof window === 'undefined' ? 'https://app.openflis.com' : window.location.origin;
const uiUrl = `${origin}/api`;
const apiUrl = `${origin}/api/v1`;
const searchApiUrl = `${origin}/search/api`;

export const environment = {
    production: true,
    apiUrl: apiUrl,
    searchApiUrl: searchApiUrl,
    featureFlags: {
        partsSearchEnabled: true,
        cagePartsTabEnabled: true,
        exactSearchLookupEnabled: true,
        niinSearchFiltersEnabled: false
    },
    appInsightsConnectionString: 'InstrumentationKey=6a3d1be5-f4b3-4f83-ba9f-a705f73dc737;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=66d174a9-d52f-442e-ac03-07a431100d13',
    supportEmail: 'support@openflis.com',
    legalEmail: 'legal@synergetics.com',
    authConfig: {
        authority: 'https://prod-api-openflis.us.auth0.com',
        authWellknownEndpointUrl: 'https://prod-api-openflis.us.auth0.com/.well-known/openid-configuration',
        postLoginRoute: '/',
        forbiddenRoute: '/warn/forbidden',
        unauthorizedRoute: '/warn/unauthorized',
        // redirectUrl: `${window.location.origin}/search/callback`,
        // postLogoutRedirectUri: `${window.location.origin}/search/warn/logout`,
        redirectUrl: `${uiUrl}/callback`,
        postLogoutRedirectUri: `${uiUrl}/warn/logout`,
        clientId: 'ltfWNWzVDIlqixxbvEUMZfKWFDc3OStR',
        scope: 'openid profile offline_access email',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        ignoreNonceAfterRefresh: true,
        renewTimeBeforeTokenExpiresInSeconds: 30,
        triggerAuthorizationResultEvent: false,
        // triggerRefreshWhenIdTokenExpired: false,
        logLevel: LogLevel.Debug,
        secureRoutes: [apiUrl, searchApiUrl],
        customParamsAuthRequest: {
            audience: apiUrl,
        },
    },
    gtagEventsConfig: {
        conversion: 'AW-947070867/xSg8CN3Gnt0ZEJPPzMMD',
        accountUpgrade: 'AW-947070867/ocGTCLvXnt0ZEJPPzMMD'
    },
    metaPixelConfig: {
        pixelId: '885740214468404',
        conversion: 'CompleteRegistration',
        accountUpgrade: 'Subscribe'
    }
}
